<p-confirmDialog/>
<p-card class="p-card" header="Invoices">
  <p-table
  stripedRows
  [value]="invoices"
  responsiveLayout="scroll" 
  selectionMode="single"
  [(selection)]="selectedInvoice"
>
    <ng-template #emptymessage>
      <tr>
          <td colspan="5">No invoices found.</td>
      </tr>
  </ng-template>
  
  <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Invoice #</th>
        <th>Invoice Date</th>
        <th>Due Date</th>
        <th>Period</th>
        <th>Amount</th>
        <th>Status</th>
        <th></th>
      </tr>
      </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData">
        <td>{{rowData.invoice_number}}</td>
        <td>{{rowData.createdAt | date}}</td>
        <td>{{rowData.due_date | date}}</td>
        <td>{{rowData.lines?.data[0]?.period_start | date}}</td>
        <td>{{rowData.including_tax | currency: 'USD'}}</td>
        <td>
          <span [ngClass]="rowData.status === 'PAID' ? 'green' : rowData.status === 'Pending' ? 'orange' : 'red'">
            {{rowData.status}}
          </span>
        </td>
        <td style="text-align: right;">
          <p-button
            (click)="selectedInvoice = rowData; menu.toggle($event)"
            icon="pi pi-ellipsis-v" />
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-menu appendTo="body" #menu [model]="items" [popup]="true" />

</p-card>
